﻿<script>
	import FormRow from "../../../components/FormRow.svelte";
	import FormColumn from "../../../components/FormColumn.svelte";
	import Select from "../../../components/Select.svelte";


	let userSelect = null;
	let brokerList = [
		{ name: "CommSec" },
		{ name: "Nabtrade" },
		{ name: "Westpac Share Trading" },
		{ name: "CMC Markets Invest" },
		{ name: "WeBull" },
		{ name: "Superhero" },
		{ name: "IG" },
		{ name: "Bell Direct" },
		{ name: "Stake" },
		{ name: "Net Wealth" },
		{ name	: "Other" }
	];
	$:console.log("userSelect", userSelect);
</script>

<FormRow>
	<FormColumn>
	<Select
		label="For guidance on how to retrieve your trade files, please select your broker below"
		bind:value={userSelect}
		optionList={brokerList}
		textProperty="name"
		valueProperty="name"
		required />
	</FormColumn>
</FormRow>

{#if userSelect}
<FormRow>
	<FormColumn>
		<p>Here are the steps to download your transaction history</p>
	</FormColumn>
</FormRow>

<FormRow>
	<FormColumn>
	{#if userSelect === "CommSec"}
		<span style="text-decoration: underline;">Web:</span> Go to <em>Portfolio &gt; Accounts &gt;Transactions</em>. From Financial Year 2025 / 2026, go to Transaction Summary and choose the CSV file for download.
		<br>
		<span style="text-decoration: underline;">App:</span> Go to <em>More &gt; Statements</em>. From Financial Year 2025 / 2026, go to Transaction Summary and choose the CSV file for download.
	{:else if userSelect === "Nabtrade"}
		<span style="text-decoration: underline;">Web:</span> Go to <em>Portfolio &gt; Statements and Reports &gt; Transactions report</em>. Add a date range of 1 July 2025 to 30 June 2026. Select Export Excel to download.
	{:else if userSelect === "Westpac Share Trading"}
		<span style="text-decoration: underline;">Web:</span> Go to <em>Overview &gt; Exports and reports &gt; Transactions &gt; Export CSV</em>. Choose a date range from 1 July 2025 to 30 June 2026. Select accounts, choose a file (CSV) and date format, and select Export.
		<br>
		<span style="text-decoration: underline;">App:</span> Go to the <em>Smart Search</em> bar, type "Recent transactions", and select Download recent transactions. Select your account, a transaction period of 1 July 2025 to 30 June 2026, then select Download.
	{:else if userSelect === "CMC Markets Invest"}
		Go to <em>Account &gt; Confirmations</em>. Choose to sort table by the stock code 'COH'. Select Date Range then select 'Last financial year'. In the Download drop down, select CSV and then Download.
	{:else if userSelect === "WeBull"}
		Select the <em>WeBull logo. Go to Account Overview &gt; Security &gt; History</em>. Use the filter option to change the custom date range to 1 July 2025 to 30 June 2026. Click Download, and enter your email address to receive the CSV trade records.
	{:else if userSelect === "Superhero"}
		Go to <em>Reports</em>. Select 'Last financial year' (1 July 2025 to 30 June 2026). Go to Transaction Statement and choose the green CSV file option for download.
	{:else if userSelect === "IG"}
		Go to <em>My Workspace &gt; History (clock icon). Select View Full History &gt; Trade History</em>. Select Date, and choose Last Financial year (1 July 2025 to 30 June 2026). Select 'Show History', and then 'Download CSV'.
	{:else if userSelect === "Bell Direct"}
		Go to <em>Orders &gt; Contract Note History</em>. Download the Excel file.
	{:else if userSelect === "Stake"}
		<span style="text-decoration: underline;">Web:</span> <em>Menu &gt; Tax & documents</em>. At Investment activity, select the 'XLSX' option to download.
		<br>
		<span style="text-decoration: underline;">App:</span> Go to <em>More &gt; Tax & documents &gt; FY 2025-26</em>. At 'Investment activity', select the Download button, and choose the 'Excel' option.
	{:else if userSelect === "Net Wealth"}
		Go to <em>My Account &gt; My Portfolio &gt; Statements</em>. In Financial Year 2025 / 2026, choose the CSV option of the 'Transaction Summary'.
	{:else if userSelect === "Other"}
		Navigate to your Account History or Statements. Download a CSV or Excel transaction summary or trade history for Financial Year 2025 / 2026.
		<br>
		For further support, you can contact your broker directly. Some customer service contact numbers are below:
		<br>
		<div style="margin-left: 1rem;">
			<strong>HSBC:</strong> 1300 301 168
			<br>
			<strong>Bendigo Invest Direct:</strong> 1300 788 982
			<br>
			<strong>InteractiveBrokers:</strong> +61 (2) 7251 0088
			<br>
			<strong>SelfWealth:</strong> 1800 577 502
			<br>
			<strong>St. George Directshares:</strong> 1300 133 500
			<br>
			<strong>MooMoo:</strong> 1300 086 668
			<br>
			<strong>Tiger Brokers:</strong> 02 9169 6999
		</div>
	{/if}
	</FormColumn>
</FormRow>
{/if}